import { GET_MY_PROFILE } from "./types";

import { apiCallV2 } from "../../utils/api";

export const GetMyProfile = (page, count, filter, sort) => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "/admin/get-super-user-profile", "", localStorage.getItem("access-token"), {});

    dispatch({
        type: GET_MY_PROFILE,
        data: res?.data?.data,
    });
};

export const SetMyProfile = (profile) => async (dispatch, getState) => {
    dispatch({
        type: GET_MY_PROFILE,
        data: profile,
    });
};
